import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "topLogo"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "logo-my" }, "my", -1)
const _hoisted_3 = { class: "qrMobile" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "qrAppCode" }, null, -1)
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "app-icon sicon-home-alt" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "app-icon sicon-cart" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "app-icon sicon-document-stack" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "app-icon sicon-message-writing" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "app-icon sicon-calendar-days" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "app-icon sicon-cloud" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "app-icon sicon-grid" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_tab_button = _resolveComponent("ion-tab-button")!
  const _component_ion_tab_bar = _resolveComponent("ion-tab-bar")!
  const _component_ion_tabs = _resolveComponent("ion-tabs")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.token)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, [
          _hoisted_2,
          _createTextVNode("celestetic.")
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ion_page, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("p", null, [
            _createElementVNode("small", {
              innerHTML: _ctx._t('{qr_code_message}')
            }, null, 8, _hoisted_5)
          ])
        ]),
        _createVNode(_component_ion_tabs, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_router_outlet),
            (_ctx.token)
              ? (_openBlock(), _createBlock(_component_ion_tab_bar, {
                  key: 0,
                  style: _normalizeStyle(_ctx.level === 'digital' ? { height: '180px' } : {}),
                  slot: "bottom",
                  translucent: true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_tab_button, {
                      tab: "home",
                      href: "/home"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6,
                        _createTextVNode(),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx._t('découvrir')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_tab_button, {
                      tab: "cart",
                      href: "/cart"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7,
                        _createTextVNode(),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx._t('commander')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_tab_button, {
                      tab: "orders",
                      href: "/orders"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _createTextVNode(),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx._t('commandes')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.level && _ctx.level !== 'digital')
                      ? (_openBlock(), _createBlock(_component_ion_tab_button, {
                          key: 0,
                          class: "no-mobile",
                          tab: "messages",
                          href: "/messages"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9,
                            _createTextVNode(),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx._t('messages')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.level && _ctx.level !== 'digital')
                      ? (_openBlock(), _createBlock(_component_ion_tab_button, {
                          key: 1,
                          class: "no-mobile",
                          tab: "calendar",
                          href: "/calendar"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10,
                            _createTextVNode(),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx._t('rendez-vous')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.level && _ctx.level !== 'digital')
                      ? (_openBlock(), _createBlock(_component_ion_tab_button, {
                          key: 2,
                          class: "no-mobile",
                          tab: "marketing",
                          href: "/marketing"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11,
                            _createTextVNode(),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx._t('marketing')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_tab_button, {
                      tab: "company",
                      href: "/company"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createTextVNode(),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx._t('plus')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["style"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}